// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(status) {
  switch (status) {
    case "HARDCOPY" :
        return /* Hardcopy */0;
    case "SOFTCOPY" :
        return /* Softcopy */1;
    default:
      return ErrorUtils$Catalyst.raiseError("DeliveryNoteType.res", "Invalid delivery note type", status);
  }
}

function toString(stauts) {
  if (stauts) {
    return "SOFTCOPY";
  } else {
    return "HARDCOPY";
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
